var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import CargomaticInput from 'components/v2/input';
import Spinner from 'components/ui/Spinner';
import Alert from 'components/ui/Alert';
import { getMissingReferenceNumbers } from 'utils/ShipmentWebAPIUtils';
import { isIntermodalShipmentType } from 'helpers/shipment-types';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
export default function MissingReferenceNumbers({ stop, shipment, onInputChange, dataTestId }) {
    const { t } = useTranslation();
    const action = stop === null || stop === void 0 ? void 0 : stop.action;
    const [isLoading, setIsLoading] = useState(true);
    const [currMissingReferenceNumbers, setCurrMissingReferenceNumbers] = useState([]);
    async function fetchMissingReferencNumbers(shipment) {
        var _a, _b;
        try {
            const _c = (await getMissingReferenceNumbers(shipment)).entity.result, { present } = _c, missingReferenceNumbers = __rest(_c, ["present"]);
            const currStage = findCurrentStage(action);
            setCurrMissingReferenceNumbers((_b = (_a = missingReferenceNumbers[currStage]) === null || _a === void 0 ? void 0 : _a.missing) !== null && _b !== void 0 ? _b : []);
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setIsLoading(false);
        }
    }
    function findCurrentStage(action) {
        switch (action) {
            case 'pickup':
                return 'PRIOR_TO_PICKUP';
            case 'deliver':
                return 'PRIOR_TO_DELIVERY';
            default:
        }
    }
    useEffect(() => {
        setIsLoading(true);
        if (featureEnabled(CONFIGURED_FEATURES.SSR) && isIntermodalShipmentType(shipment)) {
            fetchMissingReferencNumbers(shipment);
        }
    }, []);
    function renderSpinner() {
        return React.createElement(Spinner, { "data-testid": dataTestId });
    }
    function renderMissingReferenceNumbers() {
        if (currMissingReferenceNumbers === null || currMissingReferenceNumbers === void 0 ? void 0 : currMissingReferenceNumbers.length) {
            return ((React.createElement("div", { "data-testid": dataTestId, className: "mt-3 mb-4" },
                React.createElement("hr", { "data-testid": "hr-f490e19c" }),
                React.createElement(Alert, { dataTestId: "Alert-1e3f7825", type: "warning" },
                    " ",
                    t('PLEASE_PROVIDE_REFERENCE_NUMBERS')),
                React.createElement("div", { "data-testid": "div-f17d431b", className: "mb-4 mt-4 grid grid-cols-3 gap-4" }, currMissingReferenceNumbers.map((missingReferenceNumber, index) => (React.createElement(CargomaticInput, { dataTestId: `CargomaticInput-1f126bcc-${index}`, id: missingReferenceNumber, label: t(missingReferenceNumber === null || missingReferenceNumber === void 0 ? void 0 : missingReferenceNumber.toUpperCase()), type: "text", onChange: (value) => onInputChange(missingReferenceNumber, value) })))))));
        }
        return React.createElement("div", { "data-testid": "div-292d2fc0" });
    }
    return isLoading ? renderSpinner() : renderMissingReferenceNumbers();
}
